export default {
  form: {
    tax_id: {
      label: 'Número fiscal',
      placeholder: 'Introduzir número fiscal',
    },
    has_vat: {
      label: 'O seu negócio está registado para IVA?',
    },
    vat_id: {
      label: 'IVA',
      placeholder: 'IVA',
      tooltip: 'Um número de IVA é um número fiscal único que identifica o seu negócio',
    },
    tax_percentage: {
      label: 'Percentagem de imposto',
      placeholder: 'Percentagem de imposto',
    },
    has_dedicated_products_tax: {
      label: 'A % de imposto varia consoante o produto',
    },
  },
  buttons: {
    next: 'Seguinte',
    back: 'Voltar',
    skip: 'Ignorar',
  },
};
